import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight, BarChart2, Globe, Users, Shield, Zap, Clock, Award, Cpu, Database, Cloud } from 'lucide-react';
import Hero from '../components/Hero';
import FeatureCard from '../components/FeatureCard';
import TestimonialCard from '../components/TestimonialCard';
import SectionHeading from '../components/SectionHeading';
import PartnerCard from '../components/PartnerCard';

const Home = () => {
  return (
    <>
      <Hero 
        title="Solutions technologiques innovantes pour l'Afrique et le reste du monde"
        subtitle="AMOGOTech développe des solutions numériques adaptées aux défis numerique."
        ctaText="Découvrir nos produits"
        ctaLink="/products"
        secondaryCtaText="Nous contacter"
        secondaryCtaLink="/contact"
        imageSrc="https://media.techtribune.net/uploads/2020/12/Software-Development-Team2.jpg"
        imageAlt="AMOGOTech solutions technologiques"
      />

      {/* Features Section */}
      <section className="section">
        <div className="container">
          <SectionHeading
            title="Pourquoi choisir AMOGOTech ?"
            subtitle="Nous développons des solutions technologiques adaptées aux besoins du marché africain et mondial, en mettant l'accent sur l'innovation et la qualité."
          />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <FeatureCard 
              icon={Globe}
              title="Solutions localisées"
              description="Nos produits sont conçus spécifiquement pour répondre aux défis du marché africain et mondial."
              delay={0.1}
            />
            <FeatureCard 
              icon={Zap}
              title="Performance optimale"
              description="Nos applications sont optimisées pour fonctionner efficacement."
              delay={0.2}
            />
            <FeatureCard 
              icon={Shield}
              title="Sécurité renforcée"
              description="La protection des données est notre priorité, avec des systèmes de sécurité de pointe."
              delay={0.3}
            />
            <FeatureCard 
              icon={Users}
              title="Support client dédié"
              description="Notre équipe est disponible pour vous accompagner à chaque étape de votre parcours."
              delay={0.4}
            />
            <FeatureCard 
              icon={Clock}
              title="Mise en œuvre rapide"
              description="Déploiement rapide et efficace pour minimiser les perturbations de votre activité."
              delay={0.5}
            />
            <FeatureCard 
              icon={Award}
              title="Qualité certifiée"
              description="Nos solutions respectent les normes internationales de qualité et de sécurité."
              delay={0.6}
            />
          </div>
        </div>
      </section>

      {/* Products Preview Section */}
      <section className="section relative">
        <div className="absolute inset-0 bg-gradient-to-b from-dark-300 via-dark-200 to-dark-300 -z-10"></div>
        <div className="container">
          <SectionHeading
            title="Nos solutions innovantes"
            subtitle="Découvrez nos produits phares conçus pour répondre aux besoins spécifiques du marché."
          />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true, margin: "-100px" }}
              className="glass-card overflow-hidden group"
              whileHover={{ 
                y: -5,
                boxShadow: '0 0 20px rgba(20, 187, 255, 0.3)'
              }}
            >
              <div className="relative overflow-hidden">
                <img 
                  src="https://codesenegal.com/static/media/logo-code-senegal.3b4e453d1e641f7f88a0.png" 
                  alt="Route Senegal" 
                  className="w-full h-48 object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-dark-300 via-dark-300/50 to-transparent"></div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-2 text-white group-hover:text-primary-500 transition-colors">Code de la Route Senegal</h3>
                <p className="text-gray-400 mb-4 group-hover:text-gray-300 transition-colors">
                 Une application éducative conçue pour aider les candidats à préparer leur examen du code de la route au Sénégal.
                </p>
                <Link 
                  to="/products#route-senegal" 
                  className="inline-flex items-center text-primary-500 font-medium hover:text-primary-400 transition-colors"
                >
                  En savoir plus <ArrowRight size={16} className="ml-1" />
                </Link>
              </div>
            </motion.div>

            {/* <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true, margin: "-100px" }}
              className="glass-card overflow-hidden group"
              whileHover={{ 
                y: -5,
                boxShadow: '0 0 20px rgba(20, 187, 255, 0.3)'
              }}
            >
              <div className="relative overflow-hidden">
                <img 
                  src="https://scontent.fdkr6-1.fna.fbcdn.net/v/t39.30808-1/473034396_122200585568085663_6041121055153532404_n.jpg?stp=dst-jpg_s200x200_tt6&_nc_cat=109&ccb=1-7&_nc_sid=2d3e12&_nc_eui2=AeFBooSzJwPjzMX9DtRvVM5AM6RbuX4Wce4zpFu5fhZx7t05dt6qUN4GIHXdyAvrJ2rrJM-Db2t1ux-4gq4p4mvM&_nc_ohc=vBBXmqRoRCgQ7kNvgGAryrZ&_nc_oc=AdhoromX_j5F3aepsCrsIvFxtkRPnCLvQBkq9f89XI9G5PTJv1Cn8093F6X_zV849Iw&_nc_zt=24&_nc_ht=scontent.fdkr6-1.fna&_nc_gid=ALYBPAy0IGEdel6BIhMGiBo&oh=00_AYG_42mBWIoupfZxBi9pbwlfuqTlAT55L8FPe0SrYaGKPg&oe=67D4C8F0" 
                  alt="Multichange" 
                  className="w-full h-48 object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-dark-300 via-dark-300/50 to-transparent"></div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold mb-2 text-white group-hover:text-primary-500 transition-colors">Multichange</h3>
                <p className="text-gray-400 mb-4 group-hover:text-gray-300 transition-colors">
                MultiChange est une application mobile innovante qui permet de réaliser des transferts d'argent instantanés et sécurisés entre différents réseaux de mobile money.
                </p>
                <Link 
                  to="/products#multichange" 
                  className="inline-flex items-center text-primary-500 font-medium hover:text-primary-400 transition-colors"
                >
                  En savoir plus <ArrowRight size={16} className="ml-1" />
                </Link>
              </div>
            </motion.div> */}
          </div>

          <div className="text-center mt-12">
            <Link to="/products" className="btn-primary">
              Voir tous nos produits <ArrowRight size={18} className="ml-2" />
            </Link>
          </div>
        </div>
      </section>

      {/* Technologies Section */}
      <section className="section">
        <div className="container">
          <SectionHeading
            title="Technologies de pointe"
            subtitle="Nous utilisons les technologies les plus avancées pour développer des solutions performantes et évolutives."
          />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true, margin: "-100px" }}
              className="glass-card p-6 text-center group"
              whileHover={{ 
                y: -5,
                boxShadow: '0 0 20px rgba(20, 187, 255, 0.3)'
              }}
            >
              <div className="inline-flex items-center justify-center p-4 bg-primary-500/10 rounded-full text-primary-500 mb-4 group-hover:bg-primary-500/20 transition-colors duration-300">
                <Cpu size={32} className="drop-shadow-[0_0_8px_rgba(20,187,255,0.7)]" />
              </div>
              <h3 className="text-xl font-semibold mb-2 text-white group-hover:text-primary-500 transition-colors">Infrastructure Cloud</h3>
              <p className="text-gray-400 mb-4 group-hover:text-gray-300 transition-colors">
                Hébergement cloud haute disponibilité pour garantir une performance continue et fiable.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              viewport={{ once: true, margin: "-100px" }}
              className="glass-card p-6 text-center group"
              whileHover={{ 
                y: -5,
                boxShadow: '0 0 20px rgba(20, 187, 255, 0.3)'
              }}
            >
              <div className="inline-flex items-center justify-center p-4 bg-primary-500/10 rounded-full text-primary-500 mb-4 group-hover:bg-primary-500/20 transition-colors duration-300">
                <Database size={32} className="drop-shadow-[0_0_8px_rgba(20,187,255,0.7)]" />
              </div>
              <h3 className="text-xl font-semibold mb-2 text-white group-hover:text-primary-500 transition-colors">Bases de données performantes</h3>
              <p className="text-gray-400 mb-4 group-hover:text-gray-300 transition-colors">
                Technologies de bases de données robustes pour assurer la gestion optimale des données à grande échelle.
              </p>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              viewport={{ once: true, margin: "-100px" }}
              className="glass-card p-6 text-center group"
              whileHover={{ 
                y: -5,
                boxShadow: '0 0 20px rgba(20, 187, 255, 0.3)'
              }}
            >
              <div className="inline-flex items-center justify-center p-4 bg-primary-500/10 rounded-full text-primary-500 mb-4 group-hover:bg-primary-500/20 transition-colors duration-300">
                <Cloud size={32} className="drop-shadow-[0_0_8px_rgba(20,187,255,0.7)]" />
              </div>
              <h3 className="text-xl font-semibold mb-2 text-white group-hover:text-primary-500 transition-colors">Solutions Cloud</h3>
              <p className="text-gray-400 mb-4 group-hover:text-gray-300 transition-colors">
                Infrastructure cloud optimisée pour une flexibilité et une scalabilité maximales.
              </p>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="section bg-dark-300">
        <div className="container">
          <SectionHeading
            title="Témoignages"
            subtitle="Découvrez ce que nos clients disent de nous."
          />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
            <TestimonialCard
              name="Awa Ndiaye"
              position="Responsable IT"
              company="Société ISHCOM"
              testimonial="AMOGOTech a su comprendre nos besoins spécifiques et nous a livré une solution qui a optimisé nos processus opérationnels."
              imageSrc={"https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg"}
            />
            <TestimonialCard
              name="Assane Fall"
              position=""
              company="Utilisateur"
              testimonial="Ce qui m'impressionne avec Multichange, c'est sa simplicité d'utilisation. En quelques clics, l'argent arrive à destination, et je n'ai jamais eu de soucis avec la sécurité. Une application à adopter sans hésitation."
              imageSrc={"https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg"}
            />
            <TestimonialCard
              name="Fatou Sow"
              position="Chef de projet"
              company="Start-up GIVENone"
              testimonial="Grâce aux solutions d'AMOGOTech, nous avons pu améliorer nos performances et étendre nos services à d'autres pays."
              imageSrc={"https://img.freepik.com/free-vector/blue-circle-with-white-user_78370-4707.jpg"}
            />
          </div>
        </div>
      </section>

      {/* Partners Section */}
      <section className="section">
        <div className="container">
          <SectionHeading
            title="Nos partenaires"
            subtitle="Nous collaborons avec les meilleures entreprises pour offrir des solutions de qualité."
          />

<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"> 
  <PartnerCard name="Orange" imageSrc="https://goamobile.com/logosent/orange@221@-L-2021-12-31_13-24-24Orange_logo_3.png" />
<PartnerCard name="SendText" logo="https://www.multichange-sn.com/logo1.png" />
  <PartnerCard name="Wave" logo="wave.png" />
  <PartnerCard name="Expresso" logo="wave.png" />
  <PartnerCard name="Yas" logo="wave.png" />
</div>

        </div>
      </section>
    </>
  );
};

export default Home;
